import './App.css';
import {
  Navigate,
  RouteObject,
  useRoutes
} from "react-router-dom";
import { DashboardFactory } from './presentation/sdp/dashboard/dashboard-factory';
import { DashboardFactory as DashboardScpFactory } from './presentation/scp/dashboard/dashboard-factory';
import { LoginFactory } from './presentation/login/login-factory';
import { OfficialDiarySearchFactory } from './presentation/sdp/official-diary/official-diary-search-factory';
import { OfficialDiaryDetailFactory } from './presentation/sdp/official-diary/official-diary-detail-factory';
import { SubmissionPublicationSearchFactory } from './presentation/sdp/submisson-publication/submission-publication-search-factory';
import { OfficialDiaryPublicationFactory } from './presentation/sdp/publication/official-diary-publication-factory';
import { PageNotFoundFactory } from './presentation/page-not-found-factory';
import { PageUnauthorizedFactory } from './presentation/page-unauthorized-factory';
import ApplicationAppService from './application/platform/application-app-service';
import { PurchaseSearchFactory } from './presentation/scp/purchase/purchase-search-factory';
import { PurchaseCreateEditFactory } from './presentation/scp/purchase/purchase-create-edit-factory';
import { UnidEntitySearchFactory } from './presentation/scp/unid-entity/unid-entity-search-factory';
import { UnidEntityCreateFactory } from './presentation/scp/unid-entity/unid-entity-create-factory';
import { ContractSearchFactory } from './presentation/scp/contract/contract-search-factory';
import { ContractCreateEditFactory } from './presentation/scp/contract/contract-create-edit-factory';
import { AmendmentListFactory } from './presentation/scp/contract/amendment-list-factory';
import { AmendmentCreateEditFactory } from './presentation/scp/contract/amendment-create-edit-factory';

const applicationData = ApplicationAppService.getApplicationData();

const ProtectedRoute = ({ children }: { children: any }) => {
  // Verifica autenticação dinamicamente a cada render
  const authorizationData = ApplicationAppService.getAuthenticationData();

  if (!authorizationData) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

const routesSdp = (): RouteObject[] => {
  var routes: RouteObject[] = [
    {
      path: "/dashboard",
      element: (
        <ProtectedRoute>
          <DashboardFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/remessas-publicacao",
      element: (
        <ProtectedRoute>
          <SubmissionPublicationSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/remessas-publicacao/detalhes/:submissionPublicationId",
      element: (
        <ProtectedRoute>
          <SubmissionPublicationSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/diario-oficial",
      element: (
        <ProtectedRoute>
          <OfficialDiarySearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/diario-oficial/detalhes/:officialDailyId",
      element: (
        <ProtectedRoute>
          <OfficialDiaryDetailFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/diario-oficial/publicar/:submissionPublicationId?",
      element: (
        <ProtectedRoute>
          <OfficialDiaryPublicationFactory />
        </ProtectedRoute>
      )
    },
  ];
  return routes;
}

const routesScp = (): RouteObject[] => {

  var routes: RouteObject[] = [
    {
      path: "/dashboard",
      element: (
        <ProtectedRoute>
          <DashboardScpFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/compras-licitacoes",
      element: (
        <ProtectedRoute>
          <PurchaseSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/compras-licitacoes/publicar/:purchaseId?",
      element: (
        <ProtectedRoute>
          <PurchaseCreateEditFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/unidades-entidade",
      element: (
        <ProtectedRoute>
          <UnidEntitySearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/unidades-entidade/adicionar",
      element: (
        <ProtectedRoute>
          <UnidEntityCreateFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos",
      element: (
        <ProtectedRoute>
          <ContractSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos/:contractId/aditivos",
      element: (
        <ProtectedRoute>
          <AmendmentListFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos/:contractId/aditivos/publicar/:sequentialId?",
      element: (
        <ProtectedRoute>
          <AmendmentCreateEditFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos/publicar/:contractId?",
      element: (
        <ProtectedRoute>
          <ContractCreateEditFactory />
        </ProtectedRoute>
      )
    },
  ];
  return routes;

}

const defaultRoutes = (): RouteObject[] => {
  var routes: RouteObject[] = [
    {
      path: "*",
      element: <PageNotFoundFactory />
    },
    {
      path: "/",
      element: <LoginFactory />
    },
    {
      path: "/unauthorized",
      element: <PageUnauthorizedFactory />
    },
  ];

  return routes;
}

const createRoutesModules = (): RouteObject[] => {
  var routes = defaultRoutes();
  if (applicationData.moduleId === 1) {
    routes.push(...routesSdp());
  } else if (applicationData.moduleId === 2) {
    routes.push(...routesScp());
  }
  return routes;
}

const App = () => {
  let routes = useRoutes(
    createRoutesModules()
  );
  return routes;
}

export default App;
